/**
 * Adds concise assistive-technology feedback to editorial carousel controls
 * without making the complete card list a live region.
 */
class EditorialCarousel extends HTMLElement {
  selectionRequest = 0;

  connectedCallback() {
    this.slideshow = this.querySelector('slideshow-component');
    this.status = this.querySelector('[data-editorial-carousel-status]');

    if (!this.slideshow || !this.status) return;

    this.addEventListener('slideshow:select', this.handleSlideSelect);
  }

  disconnectedCallback() {
    this.selectionRequest += 1;
    this.removeEventListener('slideshow:select', this.handleSlideSelect);
  }

  /**
   * Announces arrow-button selections after Horizon finishes scrolling.
   * @param {Event & { detail?: { trigger?: string, userInitiated?: boolean } }} event
   */
  handleSlideSelect = async (event) => {
    if (event.target !== this.slideshow || !event.detail?.userInitiated || event.detail.trigger !== 'select') return;

    const request = ++this.selectionRequest;

    // Horizon emits slideshow:select before smooth scrolling settles. Wait for
    // the transition so the announcement matches the final visible position.
    await new Promise((resolve) => requestAnimationFrame(resolve));
    await this.slideshow?.waitForIdle?.();

    if (!this.isConnected || request !== this.selectionRequest) return;

    const slides = this.slideshow?.slides;
    const current = this.slideshow?.current;
    const template = this.status?.dataset.slideStatusTemplate;

    if (!slides?.length || typeof current !== 'number' || !template || !this.status) return;

    const position = Math.min(Math.max(current + 1, 1), slides.length);
    this.status.textContent = template.replace('__index__', `${position}`).replace('__length__', `${slides.length}`);
  };
}

if (!customElements.get('editorial-carousel')) {
  customElements.define('editorial-carousel', EditorialCarousel);
}
